import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { GamePublicationState, GamePublicationWishlistState } from "@/const";
import { DevForm } from "@components/Forms/Fields";
import { useSubmit } from "@components/Forms/Handlers";
import { RenderForm } from "@components/Forms/Render";
import { GameUnpublishRelationship } from "@components/Game/Misc";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function Unpublish({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData } = useAppApi(url_reverse("api:game:unpublish", { game_id: gameId }));
    const [unpublishState, setUnpublishState] = useState(1);
    const gameCommonInfo = useRouteLoaderData("gameCommonInfo");
    const onFormSubmit = useSubmit();
    const [canPublish, setCanPublish] = useState(false);
    const commonInfo = useRouteLoaderData("commonInfo");

    useEffect(() => {
        if (
            gameCommonInfo.game.publication_state === GamePublicationState.DONE ||
            gameCommonInfo.game.publication_wishlist_state === GamePublicationWishlistState.DONE
        ) {
            setUnpublishState(0);
        } else if (gameCommonInfo.game.publication_state === GamePublicationState.UNPUBLISH_REQUEST) {
            setUnpublishState(-1);
        }

        setCanPublish(
            commonInfo.account?.own_developers_ids?.includes(gameCommonInfo.developer.id) ||
                gameCommonInfo.permissions.can_own ||
                commonInfo.account?.is_super
        );
    }, [gameCommonInfo, commonInfo]);

    if (!apiData) return;

    if (!canPublish) {
        return <CommonCard header={header}>{t('Функционал доступен для аккаунтов с ролью "Владелец"')}</CommonCard>;
    }

    return (
        <CommonCard header={header}>
            {unpublishState === 1 ? (
                t("Вы не можете снять игру с публикации, т.к проект еще не опубликован")
            ) : (
                <>
                    <div className="dmg-callout dmg-callout-info">
                        <Trans>
                            Для того, чтобы снять проект с публикации необходимо проверить его связи с другими
                            продуктами (Наборы, DLC и Демо). На форме ниже будет отображена полная картина по связям и
                            действиям.
                        </Trans>
                    </div>
                    {unpublishState <= 0 && (
                        <>
                            <GameUnpublishRelationship relationship={apiData.relationship} />

                            {unpublishState === 0 && (
                                <Form
                                    onSubmit={(ev) =>
                                        onFormSubmit(ev, {
                                            onOK: (resp) => {
                                                setUnpublishState(-1);
                                                setApiData(resp);
                                            },
                                        })
                                    }
                                >
                                    <RenderForm
                                        apiData={apiData}
                                        setApiData={setApiData}
                                        bareForm={true}
                                        asRow={false}
                                    />
                                    <DevForm.Button type="submit" variant="warning" name="unpublish">
                                        {t("Отправить запрос")}
                                    </DevForm.Button>
                                </Form>
                            )}
                        </>
                    )}
                </>
            )}
        </CommonCard>
    );
}
